module.exports = __webpack_public_path__ + "img/logo.b2ea888f.svg";